export const defaultForm = {
  meta: { title: "", slug: "" },
  hero: {
    headlineLine1: "",
    headlineLine2: "",
    subheadline: "",
    primaryCta: "",
    secondaryCta: "",
  },
  features: {
    sectionTitle: "Our Core Features",
    items: [],
  },
  stats: {
    imageUrl: "",
    items: [
      { value: "0+", label: "Years of Excellence" },
      { value: "0+", label: "Satisfied Clients" },
      { value: "0+", label: "Successful Projects" },
    ],
  },
  caseStudies: { sectionTitle: "Our MERN Stack Case Studies", items: [] },
  faq: {
    sectionTitle: "Frequently Asked Questions",
    imageUrl: "",
    items: [{ question: "", answer: "" }],
  },
  team: {
    sectionTitle: "Our MERN Stack Experts",
    subheading: "",
    cardStyle: "overlap", // "overlap" | "flat"
    items: [
      {
        name: "",
        role: "",
        photoUrl: "",
        experience: "",
        skills: [{ name: "", color: "bg-orange-50 text-orange-600" }],
      },
    ],
  },
  testimonials: {
    clientCount: "10,000+",
    tagline: "MERN Developers Trust Us",
    items: [
      { quote: "", reviewerName: "", reviewerRole: "", reviewerPhoto: "" },
    ],
  },
  pricing: {
    sectionTitle: "Flexible Development Packages",
    subheading: "Choose a plan that fits your business stage and scale.",
    packages: [
      {
        name: "MVP Development",
        badge: "",
        price: "From $3,000",
        priceType: "fixed",
        highlighted: false,
        features: [
          "Core Feature Development",
          "Clean MERN Setup",
          "Basic Backend Integration",
          "Deployment Support",
        ],
        ctaText: "Get Started",
        ctaUrl: "",
      },
      {
        name: "SaaS Development",
        badge: "MOST POPULAR",
        price: "From $5,000",
        priceType: "fixed",
        highlighted: true,
        features: [
          "Multi-tenant Architecture",
          "Authentication System",
          "Admin Dashboard",
          "API Development",
        ],
        ctaText: "Get Started",
        ctaUrl: "",
      },
      {
        name: "Enterprise Apps",
        badge: "",
        price: "Custom Quote",
        priceType: "custom",
        highlighted: false,
        features: [
          "Custom Architecture",
          "High Scalability",
          "Security & Optimization",
          "Dedicated Support Team",
        ],
        ctaText: "Get Started",
        ctaUrl: "",
      },
    ],
  },
  footer: {
    description:
      "A specialized MERN stack agency delivering scalable full-stack applications with MongoDB, Express, React & Node.js for modern businesses.",
    usefulLinks: [
      { label: "Home", url: "/" },
      { label: "Projects", url: "/projects" },
      { label: "Pricing", url: "/pricing" },
      { label: "Team", url: "/team" },
      { label: "Testimonials", url: "/testimonials" },
      { label: "Contact", url: "/contact" },
    ],
    contactEmail: "admin@softheight.com",
    contactPhone: "+923074533954",
  },
  contact: {
    heading: "Ready To Build Your MERN App?",
    subheading:
      "Have a full-stack project in mind? We deliver production-ready MERN applications with clean code, thorough testing, and scalable architecture.",
    submitBtnText: "Submit Inquiry",
  },
};
